
import { useNavigate } from 'react-router';

import { Button, SxProps } from '@mui/material';

import useNavigateBack from 'hooks/useNavigateBack';

interface BackBtnProps {
    sx?: SxProps;
    goTo?: boolean | string;
}

/**
 * Estrutura padrão do sistema para página do tipo 1 coluna (oneColumn) (sem aside)
 * Contém header + titulo + conteudo + footer
 */
export function BackBtn({ sx, goTo }: BackBtnProps) {
    const navigate = useNavigate();
    const navigateBack = useNavigateBack();

    return (
        <Button
            variant="outlined"
            onClick={() => {
                if (typeof goTo === 'string') {
                    navigate(goTo);
                } else {
                    navigateBack();
                }
            }}
            sx={{ ...sx, flex: 'auto' }}
        >
            Voltar
        </Button>
    );
}
